import React from 'react'
import times from 'lodash/times'
import constant from 'lodash/constant'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import { getName, handlePreventAction, isRequired } from '../../../helpers'
import translate from '../../translate'
import { DetailsProps } from './models'
import { StyledDatePicker } from './style'
import { focusStateTypes } from 'src/features/ClientForm/models/focus-state.constant'
import { individualIDCardNumbersCount } from '../../../constants'

class RegistrationDetails extends React.PureComponent<Partial<DetailsProps>> {
  state = {
    focusState: focusStateTypes.NONE,
  }

  handleCardNumberInputFocus = () => {
    this.setState({ focusState: focusStateTypes.PRIMARY })
  }

  handleInputBlur = () => {
    this.setState({ focusState: focusStateTypes.NONE })
  }

  handleCardNumberAltInputFocus = () => {
    this.setState({ focusState: focusStateTypes.SECONDARY })
  }

  formatHiddenValue = (value) => times(value.toString().length, constant('*')).join('')

  render() {
    const { fields, permissions, actionType } = this.props
    const { focusState } = this.state
    return (
      <Grid.Row columns={1}>
        <Grid.Column>
          <FormLayout
            visible={!!(fields.ORG_RegDate || fields.CardNumber)}
            labelFieldProportions="5:11"
            label={translate('lbl_reg_date')}
          >
            <StyledDatePicker
              visible={!!fields.ORG_RegDate}
              type="date"
              name="ORG_RegDate"
              required={isRequired(fields.ORG_RegDate)}
            />

            <FormField
              disabled={
                actionType === 'edit' &&
                (!permissions.VIEW_CLIENT || !permissions.EDIT_CLIENT || !permissions.EDIT_CLIENT_ID)
              }
              dontParseToInt
              visible={!!fields.CardNumber}
              flags={{ symbolCounter: true }}
              name={getName(fields.CardNumber)}
              required={isRequired(fields.CardNumber)}
              type="number"
              minLength={1}
              // maxLength={individualIDCardNumbersCount}
              unsetMaxLength={true}
              onFocus={this.handleCardNumberInputFocus}
              onCopy={handlePreventAction}
              onCut={handlePreventAction}
              onPaste={handlePreventAction}
              onDrag={handlePreventAction}
              onDrop={handlePreventAction}
              onBlur={this.handleInputBlur}
              format={focusState === focusStateTypes.SECONDARY ? this.formatHiddenValue : undefined}
            />
          </FormLayout>

          <FormLayout visible={!!(fields.ORG_RegDate || fields.CardNumber)} labelFieldProportions="5:11" label=" ">
            <div style={{ width: '50%' }} />

            <FormField
              disabled={
                actionType === 'edit' &&
                (!permissions.VIEW_CLIENT || !permissions.EDIT_CLIENT || !permissions.EDIT_CLIENT_ID)
              }
              dontParseToInt
              visible={!!fields.CardNumber}
              flags={{ symbolCounter: true }}
              name="CardNumberAlt"
              required={isRequired(fields.CardNumber)}
              type="number"
              minLength={1}
              // maxLength={individualIDCardNumbersCount}
              unsetMaxLength={true}
              onFocus={this.handleCardNumberAltInputFocus}
              onCopy={handlePreventAction}
              onCut={handlePreventAction}
              onPaste={handlePreventAction}
              onDrag={handlePreventAction}
              onDrop={handlePreventAction}
              onBlur={this.handleInputBlur}
              format={focusState === focusStateTypes.PRIMARY ? this.formatHiddenValue : undefined}
              // isPersonalNo
            />
          </FormLayout>
        </Grid.Column>
      </Grid.Row>
    )
  }
}

export default RegistrationDetails
